import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { ReactNode, useState } from "react";

export interface RowAction {
  label: string;
  icon?: ReactNode;
  onClick: (anchorEl?: HTMLElement | null) => void;
  color?: string;
  hidden?: boolean;
}

export const RowActions = ({ actions }: { actions: RowAction[] }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const visible = actions.filter((a) => !a.hidden);

  const close = (e?: any) => {
    e?.stopPropagation?.();
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
      >
        <MoreVertIcon fontSize="small" sx={{ color: "#565B76" }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={close}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            borderRadius: "10px",
            minWidth: 160,
            boxShadow: "0px 6px 20px rgba(20,32,79,0.12)",
          },
        }}
      >
        {visible.map((action, index) => (
          <MenuItem
            key={index}
            onClick={(e) => {
              e.stopPropagation();
              const kebab = anchorEl;
              setAnchorEl(null);
              action.onClick(kebab);
            }}
            sx={{ gap: 1, py: 1 }}
          >
            {action.icon && (
              <ListItemIcon sx={{ minWidth: "auto", color: action.color }}>
                {action.icon}
              </ListItemIcon>
            )}
            <Typography variant="body2" sx={{ color: action.color }}>
              {action.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default RowActions;
